export const getNotificationComponent = (type) => {
    switch (type) {
        case "water":
            return "WaterServiceNotification";
        case "coffee":
            return "CoffeeServiceNotification";
        case "":
        case null:
            return "DealershipNotification";
        default:
            return "DealershipNotification";
    }
};

export const NOTIFICATION_ACTIONS = Object.freeze({
    DISPLAYED: "displayed",
    CTA_CLICKED: "ctaClicked",
    DISPLAY_EXPIRED: "displayExpired",
});
